(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["club-kin-launch"] && !Shopify.designMode) return;
  try {
    
(function(){
var root=document.getElementById('club-and-kin');
if(!root||root.dataset.ckTrackingReady)return;
root.dataset.ckTrackingReady='true';
var form=document.getElementById('ClubKinWaitlist');
var params=new URLSearchParams(window.location.search);
var creative=params.get('utm_content');
var validCreative=['family_first','first_drop_pieces','three_collections'].indexOf(creative)!==-1;
var isCampaign=params.get('utm_source')==='meta'&&params.get('utm_campaign')==='ck_launch_01'&&validCreative;
var context={campaign:isCampaign?'ck_launch_01':'unattributed',creative:isCampaign?creative:'unattributed'};
var isTest=params.get('ck_test')==='1';
function emit(name,data){
if(isTest)return;
try{
if(window.Shopify&&window.Shopify.analytics&&window.Shopify.analytics.publish){
var result=window.Shopify.analytics.publish(name,data);
if(result&&result.catch)result.catch(function(){});
}
}catch(error){}
}
if(form){
var tags=form.querySelector('input[name="contact[tags]"]');
if(tags){tags.value='newsletter,club-kin-first-drop'+(isCampaign?',ck-source-meta,ck-campaign-launch-01,ck-creative-'+creative:'')+(isTest?',ck-test':'');}
var started=false;
form.addEventListener('input',function(){
if(!started){started=true;emit('club_kin_waitlist_started',context);}
});
form.addEventListener('submit',function(){
if(!form.checkValidity())return;
try{sessionStorage.setItem('ck-pending-signup',JSON.stringify({time:Date.now(),campaign:context.campaign,creative:context.creative,test:isTest}));}catch(error){}
});
}
root.querySelectorAll('[data-ck-collection]').forEach(function(link){
link.addEventListener('click',function(){
emit('club_kin_collection_clicked',{collection:link.getAttribute('data-ck-collection'),campaign:context.campaign,creative:context.creative});
});
});
var success=root.querySelector('[data-ck-success]');
if(success){
var pending=null;
try{pending=JSON.parse(sessionStorage.getItem('ck-pending-signup')||'null');sessionStorage.removeItem('ck-pending-signup');}catch(error){}
if(pending&&typeof pending.time==='number'&&Date.now()-pending.time>=0&&Date.now()-pending.time<1800000&&!pending.test){
emit('club_kin_waitlist_completed',{campaign:pending.campaign,creative:pending.creative});
}
success.focus();
}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
